export default __webpack_public_path__ + "static/media/laptop.5f9922b5.jpg";